import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faArrowLeft, faChevronRight, faArrowRight, } from '@fortawesome/free-solid-svg-icons';
import { Wrapper, First, Last, Previous, Next, PageNumber, Pages, } from './styles';
var Pagination = function (_a) {
    var search = _a.search, next = _a.next, previous = _a.previous, count = _a.count, current = _a.current, onChangePage = _a.onChangePage, team = _a.team, status = _a.status, filter = _a.filter, clouds = _a.clouds, style = _a.style, priority = _a.priority, follow_up = _a.follow_up, order = _a.order, _b = _a.pageSize, pageSize = _b === void 0 ? 10 : _b, _c = _a.ticket, ticket = _c === void 0 ? false : _c, _d = _a.invoices, invoices = _d === void 0 ? false : _d, _e = _a.isDropdown, isDropdown = _e === void 0 ? false : _e, _f = _a.isFilter, isFilter = _f === void 0 ? false : _f;
    var last = Math.ceil(count / pageSize);
    var handlePageChange = function (newPage) {
        if (ticket) {
            onChangePage(newPage, search, team, status, filter, follow_up, priority, order);
        }
        else if (invoices) {
            onChangePage(newPage, search, status, order);
        }
        else {
            onChangePage(newPage, search, filter, clouds, order);
        }
    };
    return (React.createElement(Wrapper, { style: style },
        React.createElement(First, { onClick: function () { return previous && handlePageChange(1); }, disabled: !previous },
            React.createElement(FontAwesomeIcon, { icon: faChevronLeft }),
            React.createElement(FontAwesomeIcon, { icon: faArrowLeft })),
        React.createElement(Previous, { onClick: function () { return previous && handlePageChange(previous); }, disabled: !previous },
            React.createElement(FontAwesomeIcon, { icon: faArrowLeft }),
            !isDropdown && !isFilter && React.createElement("p", null, "voltar")),
        React.createElement(Pages, null,
            previous && (React.createElement(PageNumber, { previous: true, onClick: function () { return handlePageChange(previous); } }, previous)),
            React.createElement(PageNumber, { current: previous || next }, current),
            next && (React.createElement(PageNumber, { next: true, onClick: function () { return handlePageChange(next); } }, next))),
        React.createElement(Next, { onClick: function () { return next && handlePageChange(next); }, disabled: !next },
            !isDropdown && !isFilter && React.createElement("p", null, "avan\u00E7ar"),
            React.createElement(FontAwesomeIcon, { icon: faArrowRight })),
        React.createElement(Last, { onClick: function () { return next && handlePageChange(last); }, disabled: !next },
            React.createElement(FontAwesomeIcon, { icon: faArrowRight }),
            React.createElement(FontAwesomeIcon, { icon: faChevronRight }))));
};
export default Pagination;
